import React from "react";
import { Card, CardContent, CardHeader } from "../ui/card";
// import { ChevronRight } from "lucide-react";

function SelfAccountCard({ selfAccount, onSelect }) {
  const isRejected = selfAccount?.status === "REJECTED";

  return (
    <Card>
      <CardHeader className="font-normal border-b">
        <div className="flex items-center font-geomanistBold justify-between py-[5px] my-2.5">
          Self Account
          {/* <span className="py-[5px] my-2.5 px-[13px] font-geomanistBold text-[12px] text-[#FAFAFA] bg-blueish rounded-full">
            Investment Account
          </span> */}
        </div>
      </CardHeader>
      <CardContent>
        {selfAccount?.map((Details) => {
          return (
            <>
              <hr />
              <div
                className={`flex items-center cursor-pointer rounded-b px-4 py-[22px] justify-between
            ${isRejected ? "border border-red-500" : ""}`}
                onClick={() => onSelect(Details)}
              >
                <div className="flex items-center">
                  <div className="grid gap-1">
                    <p
                      className="font-geomanistBold text-blackShade text-sm max-w-[200px] truncate"
                      title={Details?.nameOfBeni}
                    >
                      {Details?.nameOfBeni}
                    </p>

                    <p className="text-xs font-geomanistBold text-blackShade">
                      {Details?.maskAccountNo}
                      <span className="ml-1 text-greyish">
                        {" "}
                        {Details?.bankName}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="mr-5 flex items-center gap-2">
                  <span className="text-red-500 text-xs font-normal">
                    {Details?.errorMsg?.replace(/[_"]/g, "")}
                  </span>
                  {/* <ChevronRight
                    size={16}
                    color={isRejected ? "#EF4444" : "#767C8F"}
                    className="text-blackShade"
                  /> */}
                  {Details?.beneType === "HEDGEFUND" ? (
                    <span className="  rounded-full font-geomanistBold text-[12px] py-[5px] px-[10px] !bg-[#FFE2C7] text-[#010101]">
                      Hedge Fund Account
                    </span>
                  ) : (
                    <span className="py-[5px] my-2.5 px-[13px] font-geomanistBold text-[12px] text-[#FAFAFA] bg-blueish rounded-full">
                      Investment Account
                    </span>
                  )}
                </div>
              </div>
            </>
          );
        })}
      </CardContent>
    </Card>
  );
}

export default SelfAccountCard;
